var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.useLayout)?_c('router-view'):_vm._e(),(_vm.$route.meta.useLayout)?_c('a-layout',[_c('a-layout-sider',[_c('sider-bar')],1),_c('a-layout',[_c('a-layout-content',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }